import RestClient from '../../../../api/axiosInterceptor';
import { postsActions } from '../../../actions/medichat/feed/posts';

const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });
    const response = await apiCall();
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: actionType.FAILURE,
      error: error.response?.data || error.message
    });
    throw error;
  }
};

const fetchPosts = () =>
  createAsyncAction(postsActions.FETCH_POSTS, () =>
    RestClient.get('/medichat/posts/')
  );

const createPost = (content) => {
  return createAsyncAction(postsActions.CREATE_POST, () =>
    RestClient.post('/medichat/posts/', content, {
      headers: { 'Content-Type': 'application/json' }
    })
  );
};

export { fetchPosts, createPost };
